import {BaseModel} from "@/models/base";
import {ModelListas} from "@/models/sie-pedidos/modelListas";
export class DadosParaSolicitacao extends BaseModel{
  public listSexo: []
  public listTipoSolicitacao: []
}

